import { Box, Group, Stack, Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

export function PageHeader({ title, subtitle, action }: PageHeaderProps) {
  return (
    <Box mb="lg">
      <Group justify="space-between" align="flex-start" wrap="nowrap" gap="md">
        <Stack gap={4} style={{ minWidth: 0 }}>
          <Title order={1} size="h2" fw={600} style={{ letterSpacing: '-0.01em' }}>
            {title}
          </Title>
          {subtitle && (
            <Text size="sm" c="dimmed" lh={1.5}>
              {subtitle}
            </Text>
          )}
        </Stack>
        {action && <Box style={{ flexShrink: 0 }}>{action}</Box>}
      </Group>
    </Box>
  );
}
